var map = {
  "./cs.json": [
    "S6I",
    [
      48
    ]
  ],
  "./en.json": [
    "Ttv",
    [
      "th"
    ]
  ],
  "./pl.json": [
    "Cu",
    [
      460
    ]
  ],
  "./ru.json": [
    "nXn",
    [
      "x2"
    ]
  ],
  "./tr.json": [
    "Zv",
    [
      "bt"
    ]
  ],
  "./ja.json": [
    "rIH",
    [
      "ddr"
    ]
  ],
  "./zh.json": [
    "mS4",
    [
      "8le"
    ]
  ],
  "./pt-br.json": [
    "YtA",
    [
      "ibr"
    ]
  ],
  "./de.json": [
    "Th",
    [
      "t5"
    ]
  ],
  "./es.json": [
    "hc",
    [
      "jr"
    ]
  ],
  "./fr.json": [
    "ICf",
    [
      "ef3"
    ]
  ],
  "./it.json": [
    "pfZ",
    [
      "vb6"
    ]
  ],
  "./ko.json": [
    "yeR",
    [
      "8uv"
    ]
  ],
  "./pt.json": [
    "SXv",
    [
      "8c"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "vg";
module.exports = __rspack_async_context;
